import { c as _c } from "react/compiler-runtime";
import type { PropsWithStyles } from '@morpho-org/ui-v6/types';
import type { CSSProperties, ReactNode } from 'react';
import { cn } from '@morpho-org/ui-v6/utils';
import { memo } from 'react';
const TOP_ADJUSTMENT = 2;
function getMarketVaultSubTabsMobileTop(top: number) {
  if (top === 0) {
    return `calc(var(--navbar-height) + var(--mobile-tabs-height) - ${TOP_ADJUSTMENT}px)`;
  }
  return `calc(var(--navbar-height) + ${top}px - ${TOP_ADJUSTMENT}px)`;
}
export interface SubTabsStickyBackgroundProps extends PropsWithStyles {
  topPosition: number;
  /**
   * `higher` when sticky content below the strip also uses `z-1`: without a
   * higher strip z-index, that content paints over the tabs (later DOM + equal
   * z-index).
   */
  zIndexLevel?: 'default' | 'higher';
  children: ReactNode;
}
function SubTabsStickyBackground(t0) {
  const $ = _c(23);
  let children;
  let className;
  let props;
  let style;
  let t1;
  let topPosition;
  if ($[0] !== t0) {
    ({
      topPosition,
      zIndexLevel: t1,
      children,
      className,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = style;
    $[5] = t1;
    $[6] = topPosition;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    style = $[4];
    t1 = $[5];
    topPosition = $[6];
  }
  const zIndexLevel = t1 === undefined ? "default" : t1;
  const t2 = `calc(var(--navbar-height) + ${topPosition}px - 1px)`;
  let t3;
  if ($[7] !== topPosition) {
    t3 = getMarketVaultSubTabsMobileTop(topPosition);
    $[7] = topPosition;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== style || $[10] !== t2 || $[11] !== t3) {
    t4 = {
      "--subtabs-top": t2,
      "--subtabs-top-mobile": t3,
      ...style
    };
    $[9] = style;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const rootStyle = t4 as CSSProperties;
  const t5 = zIndexLevel === "higher" ? "z-2" : "z-1";
  let t6;
  if ($[13] !== className || $[14] !== t5) {
    t6 = cn("sticky top-(--subtabs-top) max-md:top-(--subtabs-top-mobile)", t5, className);
    $[13] = className;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== children) {
    t7 = <div className="px-xl -translate-x-xl flex w-[calc(100%+160px)] backdrop-blur-[8px] max-md:w-[calc(100%+20px)] max-md:translate-x-[-10px] max-md:px-[10px] @max-[1420px]/content-root:w-[calc(100%+20px)] @max-[1420px]/content-root:translate-x-[-10px] @max-[1420px]/content-root:px-[10px]">{children}</div>;
    $[16] = children;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== props || $[19] !== rootStyle || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className={t6} style={rootStyle} {...props}>{t7}</div>;
    $[18] = props;
    $[19] = rootStyle;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
export default memo(SubTabsStickyBackground);